import { render } from "./AccountsManagement.vue?vue&type=template&id=9791dc8c&ts=true"
import script from "./AccountsManagement.vue?vue&type=script&lang=ts"
export * from "./AccountsManagement.vue?vue&type=script&lang=ts"

import "./AccountsManagement.vue?vue&type=style&index=0&id=9791dc8c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__